<template>
  <BaseModal
      :cancel-text="''"
      :confirm-text="''"
      :visible="upgradeModalStore.visible"
      variant="sheet"
      @update:visible="val => (val ? null : upgradeModalStore.close())"
  >
    <!-- The header used to be a pulsing 48px gradient crown beside a two-line
         title, which on a phone pushed the offer itself below the fold of the
         sheet's own scroll area. The promise is the headline now; the chrome
         went. -->
    <template #header>
      <div class="reveal">
        <h3 class="text-start text-[1.3rem] font-bold leading-tight tracking-tight text-gray-900 dark:text-gray-50">
          {{ t('planner.upgrade_promise_title') }}
        </h3>
      </div>
    </template>
    <UpgradePlanPicker
        v-if="upgradeModalStore.visible"
        :source="upgradeModalStore.source"
        @continue="upgradeModalStore.close"
    >
      <template #intro>
        <UpgradeBenefits class="mb-3"/>
      </template>
    </UpgradePlanPicker>
  </BaseModal>
</template>

<script setup>
import { watch } from 'vue'
import { Capacitor } from '@capacitor/core'
import { useI18n } from 'vue-i18n'
import BaseModal from '@/components/BaseModal.vue'
import UpgradePlanPicker from '@/components/upgrade/UpgradePlanPicker.vue'
import UpgradeBenefits from '@/components/upgrade/UpgradeBenefits.vue'
import { useUpgradeModalStore } from '@/stores/upgradeModal'
import { useConsentStore } from '@/stores/consent'
import { reportPaywallViewed } from '@/utils/funnel'
import { currentWebPriceTier } from '@/composables/useUpgradeCheckout'
import { STANDARD_PRICE_TIER } from '@/utils/webPricing'

const { t } = useI18n()
const upgradeModalStore = useUpgradeModalStore()
const consentStore = useConsentStore()

// The locked-day modal reported its own views while this one, which is what the
// reveal and the planner banner open, reported nothing. Without it the offer
// rate has a denominator covering only one of the two surfaces that show it.
watch(() => upgradeModalStore.visible, async (visible) => {
  if (!visible) return
  const source = upgradeModalStore.source
  void reportPaywallViewed(upgradeModalStore.source)
  const isNativeMobile = Capacitor.isNativePlatform() && ['ios', 'android'].includes(Capacitor.getPlatform())
  const priceTier = isNativeMobile ? STANDARD_PRICE_TIER : await currentWebPriceTier()
  void consentStore.trackEvent('upgrade_offer_viewed', {
    surface: source,
    price_tier: priceTier,
  })
})
</script>
